import { FormHelperText,  } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers-pro";
import moment from "moment";
import React, { useEffect } from "react";
import { Control, Controller } from "react-hook-form";

type TimeInputPropsType = {
  control: Control<any, any>;
  errors: any;
  variableName: string;
  label: string;
  defaultValue?: string;
  setValue: any;
};
export default function CustomTimeInput(props: TimeInputPropsType) {
  const { control, errors, variableName, label, defaultValue, setValue } =
    props;
  //setting default value
  useEffect(() => {
    if (defaultValue) {
      setValue(variableName, moment(defaultValue).format("HH:mm:ss"));
    }
  }, [defaultValue, setValue, variableName]);
  return (
    <Controller
      control={control}
      name={variableName}
      render={({ field: { onChange, value } }) => {
        return (
          <>
            <TimePicker
                           value={value ? moment(value, "HH:mm:ss") : null}
              label={label}
              onChange={(selectedDateObj: moment.Moment | null) => {
                onChange(selectedDateObj?.set("seconds", 0).format("HH:mm:ss"));
              }}
              format="HH:mm"
              ampm={false}
            />
            <FormHelperText error={!!errors[variableName]}>
              {errors[variableName] ? errors[variableName].message : ""}
            </FormHelperText>
          </>
        );
      }}
    />
  );
}
